import { render } from "./VyvojoveView.vue?vue&type=template&id=61054657"
const script = {}

import "./VyvojoveView.vue?vue&type=style&index=0&id=61054657&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__